import { FunctionComponent, useEffect, useState } from "react";

interface PasswordFieldProps {
  onChangeCallback?: (value: string) => void;
  formwasSubmitted: boolean
}

export const PasswordField: FunctionComponent<PasswordFieldProps> = ( { onChangeCallback, formwasSubmitted } ) => {

    const [pass, setPass] = useState<string>('');
    const [isPassValid, setIsPassValid] = useState<boolean | null>(null)
    const [rulesStatus, setRulesStatus] = useState({
        length: false,
        lowercase: false,
        uppercase: false,
        digit: false,
        special: false,
    });

    const regexPass = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,32}$/;
    
    const handlePassChange = (e:any) => {
        const input = e.target.value;
        setPass(input);
        setIsPassValid(regexPass.test(input));
        validatePassword(input)
        onChangeCallback?.(input);
    };

    const validatePassword = (password:string) => {
        const rules = {
            length: password.length >= 8 && password.length <= 32,
            lowercase: /[a-z]/.test(password),
            uppercase: /[A-Z]/.test(password),
            digit: /\d/.test(password),
            special: /[^A-Za-z0-9]/.test(password)
        };

        setRulesStatus(rules);
    }

    useEffect ( () => {
        if (!formwasSubmitted) setIsPassValid(null)
    },[formwasSubmitted])

    return (
        <div className="form-input-wrapper">
            <label htmlFor="">Senha <small>(alfanúmerica)</small></label>
            <input type="password"
                value={pass}
                className={`bottomPad ${
                    isPassValid  === null
                        ? "border-gray"
                        : isPassValid
                        ? "border-green"
                        : "border-red"
                    }`}
                onChange={handlePassChange} 
                placeholder="Digite sua senha" />
            {isPassValid === false && (
                    <div className="text-danger">
                        <p>Entrada inválida, corrija:</p>
                        <ul>
                            <li style={{ color: rulesStatus.length ? "green" : "red" }}>
                            8 a 32 caracteres
                            </li>
                            <li style={{ color: rulesStatus.special ? "green" : "red" }}>
                            Pelo menos 1 caractere especial
                            </li>
                            <li style={{ color: rulesStatus.digit ? "green" : "red" }}>
                            Pelo menos 1 dígito
                            </li>
                            <li style={{ color: rulesStatus.uppercase ? "green" : "red" }}>
                            Pelo menos 1 letra maiúscula
                            </li>
                            <li style={{ color: rulesStatus.lowercase ? "green" : "red" }}>
                            Pelo menos 1 letra minúscula
                            </li>
                        </ul>
                    </div>
                )}
            {isPassValid === true && (
                <p className="text-success">
                    Senha atende aos requisitos.
                </p>
            )}
        </div>
    )
}